import { QueryClient } from '@tanstack/react-query';

import { SearchHospitalService } from '@/services/hospital/SearchHospitalService';
import { useSearchKoreaAddressV2Query } from '../faceToFace.gql.impl';

interface Props {
  siDoCode: string | null;
  siGunGuCode: string | null;
}

const useSearchKoreaAddressV2 = (props: Props) => {
  const { siDoCode, siGunGuCode } = props;
  const { data, isLoading } = useSearchKoreaAddressV2Query(
    {
      request: {
        siDoCode,
        siGunGuCode,
      },
    },
    {
      select: SearchHospitalService.parseKoreaAddressV2,
    }
  );
  return { data, isLoading };
};

export default useSearchKoreaAddressV2;

const prefetchQuery = async (queryClient: QueryClient, props: Props) => {
  await queryClient.prefetchQuery(
    useSearchKoreaAddressV2Query.getKey({
      request: {
        siDoCode: props.siDoCode,
        siGunGuCode: props.siGunGuCode,
      },
    }),
    useSearchKoreaAddressV2Query.fetcher({
      request: {
        siDoCode: props.siDoCode,
        siGunGuCode: props.siGunGuCode,
      },
    })
  );
};

useSearchKoreaAddressV2.prefetchQuery = prefetchQuery;

const fetcher = async (props: Props) => {
  const response = await useSearchKoreaAddressV2Query.fetcher({
    request: {
      siDoCode: props.siDoCode,
      siGunGuCode: props.siGunGuCode,
    },
  })();

  const data = SearchHospitalService.parseKoreaAddressV2(response);

  return data;
};

useSearchKoreaAddressV2.fetcher = fetcher;
